<template>
  <v-snackbar multi-line shaped right :timeout="timeout" v-model="show" :color="color">
    <div class="d-flex align-center justify-space-between">
      <span>{{ message }}</span>
      <v-btn text @click="show = false">Close</v-btn>
    </div>
  </v-snackbar>
</template>

<script>
  export default {
    name: 'NotificationSnackbar',
    data: () => ({
      show: false,
      message: '',
      color: '',
      options: {},
    }),
    computed: {
      timeout: function () {
        // eslint-disable-next-line no-prototype-builtins
        return this.options.hasOwnProperty('timeout') ? this.options.timeout : 3000
      }
    },
    created() {
      this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'notifier/SHOW_MESSAGE') {
          this.message = state.notifier.content
          this.color = state.notifier.color
          this.options = state.notifier.options
          this.show = true
        }
      })
    }
  }
</script>
